import { render, staticRenderFns } from "./ShowQrCode.vue?vue&type=template&id=23360a70"
import script from "./ShowQrCode.vue?vue&type=script&lang=js"
export * from "./ShowQrCode.vue?vue&type=script&lang=js"
import style0 from "./ShowQrCode.vue?vue&type=style&index=0&id=23360a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports